import React, { useContext, useState } from 'react';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from 'libraries/Dialog';
import { reapplyCandidate } from 'requests/AssessmentRequests';
import { observer } from 'mobx-react-lite';
import CircularProgress from '@mui/material/CircularProgress';
import AssesmentEvents from 'events/AssessmentEvents';
import { appCtx } from '../../appStore';

const styles = () => ({
    actionButton: {
        fontWeight: 700,
        paddingRight: 20,
        paddingLeft: 20
    },
    deleteButton: {
        paddingRight: 40,
        paddingLeft: 40,
        fontWeight: 700,
        minWidth: 213
    },
    loader: {
        color: '#fff'
    }
});

const CandidateReinviteDialog = observer(({ classes, open, audition, onClose, columnUserUuid, callback }) => {
    const [loading, setLoading] = useState(false);
    const { flashMessage } = useContext(appCtx);
    const { uuid, name } = audition;

    const onReinvite = () => {
        setLoading(true);
        reapplyCandidate(columnUserUuid)
            .then((data) => {
                onClose();
                setLoading(false);
                if (data.success) {
                    flashMessage('Reinvited successfully', 'success');
                    if (callback) callback();
                    AssesmentEvents.CANDIDATE_REAPPLIED({
                        candidateUuid: columnUserUuid,
                        ttUUID: uuid,
                        ttName: name
                    });
                }
            })
            .catch((err) => {
                if (err.response) {
                    const { msg } = err.response.data;
                    if (msg) {
                        flashMessage(msg, 'error');
                    } else {
                        flashMessage('Something went wrong', 'error');
                    }
                }
                return Promise.reject();
            })
            .finally(() => {
                setLoading(false);
                onClose();
            });
    };

    return (
        <>
            <Dialog
                maxWidth="sm"
                titleComponent="Reinvite Candidate"
                actionComponent={(
                    <>
                        <Button
                            color="primary"
                            className={classes.actionButton}
                            onClick={onClose}
                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            className={classes.deleteButton}
                            onClick={onReinvite}
                        >
                            {
                                loading ? (
                                    <CircularProgress
                                        size={24}
                                        thickness={3}
                                        classes={{ root: classes.loader }}
                                    />
                                ) : <span>Reinvite</span>
                            }
                        </Button>
                    </>
                )}
                open={open}
                onClose={onClose}
                handleClose={onClose}
            >
                By reinviting the candidate, you'll notify them of this invitation and give them an extra attempt to access and complete the assessment.
            </Dialog>
        </>
    );
});

export default withStyles(styles)(CandidateReinviteDialog);
